export default class WeekModel {
    constructor(weeknumber, days) {
        this.name = "KW " + weeknumber;
        this.weeknumber = weeknumber;
        this.days = days;
    }
}



// WEBPACK FOOTER //
// ./src/models/week.js